import { apiClient } from '../../../app/api/apiClient';
import type { Wallet, WalletsPage } from '../types/wallet.types';

interface WalletListResponse {
  success: boolean;
  data: {
    wallets: Wallet[];
    page: number;
    limit: number;
    total: number;
  };
}

interface WalletResponse {
  success: boolean;
  wallet: Wallet;
}

export async function getWallets(page = 1, pageSize = 20, search = ''): Promise<WalletsPage> {
  const response = await apiClient.get('/api/super-admin/wallets', {
    query: { page, page_size: pageSize, ...(search.trim() ? { search: search.trim() } : {}) },
  });
  const data = (response.data as WalletListResponse).data;
  return {
    wallets: data.wallets,
    meta: { page: data.page, limit: data.limit, total: data.total },
  };
}

export async function getWallet(userId: string): Promise<Wallet> {
  const response = await apiClient.get(`/api/super-admin/wallets/${userId}`);
  return (response.data as WalletResponse).wallet;
}
